<div id="downIconCover" style="position: fixed;left:0;top:0;right:0;bottom: 0;z-index: 30000;display: none;"></div>
<div id="downIcon" (tap)="gotoMultiChoice()">
	<p id="skiptip" class="fontSize16">{{configOption ? configOption.skipText: "若信息获取足够，请点击此处进行跳转"}}</p>
</div>
<div id="mask-shade" class="fontSize16">
</div>
<div id="diaploghelpunreader"  class="fontSize12">1</div>
<div id="diaploghelphead"  (tap)="onCloseHelp(0)">&nbsp;</div>
<div id="step94-shade" class="fontSize16">
    <div id="dialoghelparrow">&nbsp;</div>
    <div id="shareIcon"></div>
    <p id="nin3" class="fontSize16 ">请点击头像查看TA<br/>想说的话。</p>
</div>

<div id="step93-shade" class="fontSize16">
    <div id="dialogueiconCopy" >&nbsp;</div>
    <div id="dialogueunreaderCopy"  class="fontSize12 ShowMe">1</div>

    <div id="emghelparrow3">&nbsp;</div>
    <p id="nin4" class="fontSize16 ">请仔细看每个方案。<br/>如果拿捏不准的话，伙伴们<br/>随时乐意为你献计献策。<br/><br/><font color='#D7B118'><b>·&nbsp;&nbsp;友情提示&nbsp;&nbsp;·</b></font><br>当选择不同方案时，提示信<br/>息也会切换到相应方案。</p>
    <div id="know3" (tap)="closeShade()" class="fontSize16">朕知道了</div>
</div>


<div id="tip1" class="tip">
    <p id="tip_message"></p>
    <div>
        <button id="viewBtn" class="btnWord fontSize16" (click)="continue();">不查看</button>
        <button id="continueBtn" class="btnWord fontSize16" (click)="onViewContent();">查看</button>
    </div>
</div>
<div id="step5-dialogue"  style="padding-bottom: 15px" >
    <div style="height:1rem" class="fontSize26">
        <div class="dialogue-title">对话</div><div class="closed" (tap)="dialogueclosed()">&nbsp;</div>
    </div>
    <div *ngFor="let people of diglogueList;let i=index" >
        <div class="left" style="display: flex;">
            <div class="font-size-16 headercenter" (tap)="onDialogueList(i)">
                <div class="{{people.icon}}" *ngIf="!(i==0 && maskType == 5)" >&nbsp;</div>
                <div *ngIf=" (i == 0 && maskType == 5)" style="width: 1.0rem;height:1.0rem" >&nbsp;</div>
                <div class="fontSize14" style="float:left;position:relative;width:1rem;text-align: center">{{people.name}} </div>
                <div *ngIf="people.unread>0 && maskType != 5" class="dialogueunreadsignal" >{{people.unread}}</div>
            </div>
            <div class="border-sharp" style="height: 65px;" (click)="onDialogueList(i)">
                <div class="graylight fontSize16"> {{people.title}}</div> <div class="gray fontSize14 light">{{people.desc}}<br/></div>
            </div>
        </div>
    </div>

</div>

<div id="step5-dialogue-list" class="fontSize18"  >
    <div style="border-bottom: 1px solid #979797;height:0.65rem;margin: 10px;">
        <div class="dialogue-content-back fontSize18" (tap)="onReturnIntroduce()">< 返回</div>
    </div>
    <ul (tap)="onDialogueTouch(i)" style="border-top: 0px solid #FFFFFF;border-bottom: 1px solid #EEEEEE;" *ngFor="let people of diglogueList[selectedPeople].List;let i = index">
        <li class="left" style="border-bottom: 1px">
            <div class="font-size-16 headercenter">
                <div class="{{diglogueList[selectedPeople].icon}}" style="margin-top: 0.0rem;">&nbsp;</div>
                <div *ngIf="people.state==0" class="small-dialogue-unreadsignal">&nbsp;</div>
            </div>
            <div class="white-sharp">
                <div class="fontSize16" style="float: none;line-height:0.5rem;"> {{diglogueList[selectedPeople].name}}</div> <div  style="float: none;line-height:0.4rem;" class="gray fontSize14">{{people.title}}</div>
            </div>
        </li>
    </ul>
    <div class="dialogue-history-title" *ngIf="diglogueList[selectedPeople].History.length>0" >历史对话</div>
    <ul (tap)="onDialogueTouch(i,1)" style="border-top: 0px solid #FFFFFF;border-bottom: 1px solid #EEEEEE;" *ngFor="let people of diglogueList[selectedPeople].History;let i = index">

        <li class="left" >
            <div class="font-size-16 headercenter">
                <div class="{{diglogueList[selectedPeople].icon}}" style="margin-top: 0.0rem;">&nbsp;</div>
                <div *ngIf="people.state==0" class="small-dialogue-unreadsignal">&nbsp;</div>
            </div>
            <div class="white-sharp">
                <div class="fontSize16" style="float: none;line-height:0.5rem;"> {{diglogueList[selectedPeople].name}}</div> <div style="float: none;line-height:0.4rem;" class="gray fontSize14">{{ people.state == 2 ?"[已失效]":""  }}{{people.title}}</div>
            </div>
        </li>
    </ul>
    <div class="dialogue-empty-title" *ngIf="diglogueList[selectedPeople].List.length==0 && diglogueList[selectedPeople].History.length==0" >没有新对话</div>
</div>
<div id="single-choice" class="fontSize16" >
  <div class="totast-title" *ngIf="currentQuestion.id==1" [ngClass]="{'autoDisplay':currentQuestion.id == 1}">如果内容显示不全，请滑动页面</div>
    <div class="choice-type" >{{currentQuestion.type}}</div><div class="choice-title">{{currentQuestion.title}}</div>
    <div style="clear: both;"></div>
    <div *ngIf="currentQuestion.sub < 3 && showChoiceDetail" [ngStyle]="{'padding-top' : currentQuestion.options.length>7 ? '0.1rem':'0.1rem','max-height' : currentQuestion.options.length==9 ? 'calc(100% - 4.5rem)':'calc(100% - 160px)' }" style="overflow-y: scroll;">
        <div  class="optionItem fontSize14" *ngFor="let option of SortQuestionOption();let i=index" (click)="onOptionClick($event,i)"
              [ngClass]="{'unselectedOptionItem':!getSelectItem(i) ,'selectedOptionItem':getSelectItem(i)}">
            {{option}}
        </div>
    </div>
    <div *ngIf="currentQuestion.sub == 3 && showChoiceDetail" style="padding-top: 0.1rem;max-height: calc(100% - 160px);overflow: scroll;">
        <div *ngFor="let option of SortQuestionOption();let i=index"  style="display: flex;align-items: center;">
            <div  class="optionItemWhite fontSize14" (click)="onTrueFalseClick(i)" >
                {{option}}
            </div>
            <div class="optionItemRight" [ngClass]="{'optionItemRight':!selectedMutliChoice[i],'optionItemRightBlue':selectedMutliChoice[i]}" (click)="onTrueFalseClick(i)">&nbsp;</div>
        </div>
    </div>
    <div *ngIf="currentQuestion.sub == 4 && showChoiceDetail" style="padding-top: 0.1rem;max-height: calc(100% - 160px);overflow: scroll;">
        <div *ngFor="let option of currentQuestion.options;let i=index">
            <div  class="optionItemSort fontSize14"  >
                {{option}}
            </div>
            <div *ngIf="i < (currentQuestion.options.length-1)"  class="optionItemDown"  (tap)="onDownClick(i)">&nbsp;</div>
            <div *ngIf="i >0" class="optionItemUp" (tap)="onUpClick(i)">&nbsp;</div>
        </div>
    </div>
    <div  *ngIf="currentQuestion.sub == 5 && showChoiceDetail" [ngStyle]="{'padding-top' : currentQuestion.options.length>7 ? '0.1rem':'0.7rem' , 'padding-left':'1rem'}" style="max-height: calc(100% - 180px);overflow: scroll;">

        <div  class="exceptChoiceItem fontSize14" *ngFor="let option of SortQuestionOption();let i=index" (click)="onOptionClick($event,i)"
              [ngClass]="{'unselectedOptionItem':!getSelectItem(i) ,'selectedOptionItem':getSelectItem(i)}">
            {{option}}
        </div>
    </div>
    <div *ngIf="currentQuestion.sub >= 3 && currentQuestion.sub <5  && showChoiceDetail" style="margin-top: 0.1rem;" (click)="onQuestionBtnClick($event)" >
        <div class="optionItemButton fontSize16"
        	[ngClass]="{'inactiveQuestionBtn':optionSelectedIndex<0,'activeQuestionBtn':optionSelectedIndex>=0}">
            <span>确 定</span>
        </div>
    </div>
    <div *ngIf="currentQuestion.sub == 5  && showChoiceDetail" style="margin-top: 0.1rem;"

         (click)="onQuestionBtnClick($event)">
        <div class="exceptChoiceButton fontSize16"
             [ngClass]="{'inactiveQuestionBtn':optionSelectedIndex==-1,'activeQuestionBtn':optionSelectedIndex>=0}">
            <span >确 定</span>
        </div>
    </div>
    <div *ngIf="currentQuestion.sub < 3 && showChoiceDetail"  style="margin-top: 0.4rem;" class="questionBtn fontSize16"
         [ngClass]="{'inactiveQuestionBtn':!isSelected(),'activeQuestionBtn':isSelected()}"
         (click)="onQuestionBtnClick($event)" >
        <span >确 定</span>
    </div>

</div>
<app-case-practice-message-box ></app-case-practice-message-box>
<div id="step5-email" class=""  >
    <div style="height:1.25rem">
        <div class="email-title fontSize26" style="">收件箱</div><div class="closed" (tap)="onEmailClose()">&nbsp;</div>
    </div>
    <!-- style="-webkit-overflow-scrolling: touch;overflow-y: scroll; height: 8rem" -->
    <div style="-webkit-overflow-scrolling: touch;overflow-y: scroll; height: 85%;border-top: 0px solid #000000; ">
        <div (click)="onReadEmail(i,1)" *ngFor="let email of emails;let i = index" style="border-top: 1px solid #979797; " >
            <div class="rw fontSize16" style="float:left;padding-top: 2px;" ><div style="margin-left:15px;" class="{{email.isread ? 'hasread':'unread'}}" >{{email.isread ?'已查看':'未查看'}}</div><div style="margin-left: 14px;float: left;width:1.9rem;"> {{email.name}}</div> <div style="margin-left: 1.2rem;white-space: nowrap;float: left;" class="gray">{{email.date}}</div></div>
            <div class="rw fontSize16" style="margin-left:15px;" [innerHtml]="email.subject" ></div>
            <div class="context rw fontSize14" style="padding:0 15px 0px 15px;" [innerHtml]="email.desc" ></div>
        </div>
        <div class="hist-titel" [ngStyle]="{'background-color':emaihistlst.length>0?'#F5F5F5':''}" >
            <span class="fontSize16" *ngIf="emaihistlst.length>0">历史邮件</span>
        </div>
        <div (click)="onReadEmail(i,2)" *ngFor="let email of emaihistlst;let i = index" style="border-top: 1px solid #979797; " >
            <div class="rw fontSize16" style="float:left;padding-top: 2px;" ><div style="margin-left:15px;" class="{{email.isread ? 'hasread':'unread'}}" >{{email.isread ?'已查看':'未查看'}}</div><div style="margin-left: 14px;float: left;width:1.9rem;"> {{email.name}}</div> <div style="margin-left: 1.2rem;white-space: nowrap;float: left;" class="gray">{{email.date}}</div></div>
            <div class="rw fontSize16" style="margin-left:15px;" [innerHtml]="email.subject"></div>
            <div class="context rw fontSize14" style="padding:0 15px 0px 15px;" [innerHtml]="email.desc"></div>
        </div>
    </div>
</div>

<div id="step5-email-content"  >
    <div class="email-content-title fontSize18" (tap)="onReturnEmail()">&lt; 返回</div>
    <ul>
        <li class="height20 emailbottom fontSize16" style="padding-left: 10px;"> 发件人: <span id="send_email" class="light"></span> <br/> 收件人: <span id="receiver" class="light">我</span></li>
        <li class="send_subject emailbottom fontSize16"><div id="send_subject" style="width:72%;float: left;padding-left: 10px;"></div> <div id="send_date" style="margin-left: 1.5rem;" class="left gray"></div></li>
        <li class="context fontSize14">
            <div id="email-detail" style="padding:0px 10px 0px 10px">

            </div>
        </li>
    </ul>
</div>


<div id="step5-message"  >
    <div class="title" style="height:1.25rem">
        <div class="email-title fontSize26" style="padding-left: 0.2rem;">信息</div><div class="closed" (tap)="onMessageClose()">&nbsp;</div>
    </div>
    <div class="message-body" >
        <div class="ul" (click)="onReadMessage(message)" *ngFor="let message of messagebox.List;let i = index" >
            <div class="left" style="width: 100%;padding-top:5px;padding-left: 0.4rem;">
                <div class="{{message.profilePhoto}}" >&nbsp;</div>
                <div class="{{message.state == 0 ? 'unreadsignal':'none'}}">&nbsp;</div>
                <div class="text fontSize16" >
                    <div style="float: none;margin-left: 0.2rem;">{{message.name}}</div> <div style="float: none;margin-left: 0.2rem;margin-top: 8px;" class="gray light">{{message.title}}</div>
                </div>
            </div>
        </div>
        <div *ngIf="messagebox.History.length>0" class="height20 title fontSize16">
            <span *ngIf="messagebox.History.length>0">历史信息</span>
        </div>
        <div class="ul" (click)="onReadMessage(message)" *ngFor="let message of messagebox.History;let i = index" >
            <div class="left" style="width: 100%">
                <div class="{{message.profilePhoto}}" style="margin-left:0.2rem;" >&nbsp;</div>
                <div class="{{message.state == 0 ? 'unreadsignal':'none'}}">&nbsp;</div>
                <div class="text fontSize16" >
                    <div style="float: none;margin-left: 0.2rem;">{{message.name}}</div> <div style="float: none;margin-left: 0.2rem;margin-top: 8px;" class="gray">{{message.title}}</div>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- background: url('') ; -->
<div id="step5-message-content" class="fontSize18"  >
  <app-component-scroll-title *ngIf="isShowTitle"></app-component-scroll-title>
    <div class="fontSize18" style="margin: 10px">
        <div class="message-content-back" (tap)="onReturnMessage()">&nbsp;< 返回</div>
        <div class="message-content-title light"> {{currentMessage.name}}</div>
    </div>
    <div class="message-content-body">
        <div *ngFor="let message of currentMessage.List;let i = index">
            <div class="ul fontSize16">
                <div class="{{message.t == 1 ? 'messagedetail-head ': currentMessage.profilePhoto}}" [ngStyle]="{ 'background-image':message.t ==1 ?'url('+myhead+')':''}">&nbsp;</div>
                <div class="{{message.t == 1 ? 'messagedetail-right':'messagedetail-left'}}" [ngStyle]="{ 'width':message.d.length >10 ?'60%':'auto'}"> {{message.d}}</div>
            </div>
        </div>
    </div>
</div>

<div id="step6-solution-tab" class="">
    <div *ngIf="selectedSolution" class="fontSize21" style="width: 100%">
        <div *ngFor="let s of solutionList;let i = index">
            <div class="{{(selectedSolution.type == s.type ? 'tab_active' : 'tab') + (solutionList[s.type-1].state==1?' red_yes':'')}}"  [ngStyle]="s.style" (tap)="onTabChanged(s.type-1)" >{{s.name}}</div>
        </div>
    </div>
</div>
<div id="step6-solution-content" class="fontSize16"  style="border-top-left-radius:0;">
    <ul  *ngIf="selectedSolution">

        <li class="height06 fontSize16">
            <div style="width: 4.5rem;float: left">{{selectedSolution.title}}</div>
            <div class="solutionselectedBtn fontSize16 activeQuestionBtn "
            	 [ngClass]="{'activeQuestionBtn':selectedString=='选择方案','inactiveQuestionBtn':selectedString !='选择方案'}"
                 (click)="onSolutionClick($event)" >
                <span >{{selectedString}}</span>
            </div>
            <div style="clear:both;"></div>
        </li>
        <li id="solution-detail"  class="context">
    		<div [innerHtml]="selectedSolution.d"></div>
        </li>
    </ul>
</div>
<div id="step6-solution-button" style="margin-top: 0.7rem;" class="questionBtn fontSize16"
     [ngClass]="{'inactiveQuestionBtn':!isNeedClick,'activeQuestionBtn':isNeedClick}"
     (click)="onQuestionBtnClick($event)" >
    <span id="step6-solution-button-text">确 定</span>
</div>
<div id="step7-solution-button" style="margin-top: 0.7rem;" class="questionBtn fontSize16 activeQuestionBtn"
     (click)="gotoFinish($event)" >
    <span id="step7-solution-button-text">确 定</span>
</div>


<div id="wrap" class="bg1" (tap)="onNextStage(currentIndex)">
    <div id="shade" >
        <ul style="margin-top: 0.7rem">
            <li><img src="{{assetsRoute}}/picture/casepractice/handf.png" height="50%" width="50%" style="margin-left:20px"/></li>
            <li class="fontSize18" style="margin-top:20px" >点击屏幕任意处可以<br/>进行下一步操作</li>
        </ul>
    </div>
    <div id="step2" class="fontSize16">
        <div id="step2-content">
            你是DC Mak五星度假酒店的销售经理，<br/>管理着会务、餐饮、前厅服务等部门。
        </div>
    </div>
    <div id="mindyicon"></div>
    <div id="choiceTip">
        <span class="u-tri"></span>
        <div id="tipText" class="fontSize16"></div>
    </div>

    <div id="tutorviewTip">
        <div id="tutorview-tipText" class="fontSize16"></div>
        <span class="tutorview-arrow"></span>
    </div>

    <div id="mindyReportTip"class="fontSize18">
        在与各方沟通完实施方案之后，大家就按照你的最终决策去执行了。
    </div>

    <div id="div-test"></div>
    <div id="bottom"></div>
    <div id="qfbg"></div>
    <div id="glbg"></div>
    <div id="jnbg"></div>
    <div id="wlnbg"></div>
    <div id="fkkbg"></div>
    <div id="tutorview"></div>
    <div id="mindyReportHead"></div>

    <div id="subtractOne" >&nbsp;</div>
    <div id="subtractTwo" >&nbsp;</div>

    <div id="step3" class="fontSize16">
        <div id="step3-title" style="position:relative; top:10px;background-color: #9fc0e8;border-radius: 0.08rem;color: white;vertivcal-align:middle;text-align:center;margin-left:30px;">XX</div>
        <div>
            <div id="step3-content" style="word-wrap: break-word;word-break: break-all;">
				你是DC Mak五星度假酒店的销售经理，<br/>管理着会务、餐饮、前厅服务等部门。
            </div>
        </div>
    </div>
    <div id="emgtitle" class="fontSize14">精力值</div>
    <div id="emgnumber" class="fontSize14">70/70</div>
    <div id="emgvalue">&nbsp;</div>
    <div id="emgmaxvalue">&nbsp;</div>
    <!-- [@wlnPhoneAnimation]="emailShow ? 'showWlnPhone':'hideWlnPhone'" -->
    <div id="first_fake_emailicon" class="fake_emailicon" >&nbsp;</div>
    <div id="fake_emailicon"  class="fake_emailicon">&nbsp;</div>
    <div id="emailicon" (tap)="onEmailTouch()"  >&nbsp;</div>
    <div id="emailunreader" *ngIf="unreadcount>0" class="fontSize12 {{unreadcount>0 ? 'ShowMe':''}}">{{unreadcount}}</div>
    <div id="first_fake_messageicon" class="fake_messageicon" >&nbsp;</div>
    <div id="fake_messageicon" class="fake_messageicon" >&nbsp;</div>
    <div id="messageicon" (tap)="onMessageTouch()">&nbsp;</div>
    <div id="messageunreader" *ngIf="msgunreadcount>0" class="fontSize12 {{msgunreadcount>0 ? 'ShowMe':''}}">{{msgunreadcount}}</div>
    <div id="first_fake_dialogueicon" class="fake_dialogueicon" >&nbsp;</div>
    <div id="fake_dialogueicon"  class="fake_dialogueicon" >&nbsp;</div>
    <div id="dialogueicon" (tap)="onDiglogueTouch()">&nbsp;</div>
    <div id="dialogueunreader" *ngIf="diglogueUnreadcount>0" class="fontSize12 {{diglogueUnreadcount>0 ? 'ShowMe':''}}"   >{{diglogueUnreadcount}}</div>

    <div id="step4-shade" class="fontSize16">
        <div id="emailhelparrow">&nbsp;</div>
        <div id="emghelparrow">&nbsp;</div>
        <p id="nin" class="fontSize16 ">您可以体验部分学习旅程</p>
        <p id="nin2" class="fontSize16 ">您可以体验部分学习旅程</p>
        <div (tap)="onUnlock()" id="know" class="fontSize16">朕知道了</div>
    </div>
    <!--组织架构图开始-->
    <div id="organization">
		<div class="title">组织架构图</div>
		<div class="inner"></div>
	</div>
	<!--组织架构图结束-->
</div>


<div id="choice">
    <ul>
        <li *ngFor="let option of questionOptions; let i=index" class="choiceItem" >
            {{option.short_description ? option.short_description : option.description}}
        </li>
    </ul>
</div>

<div id="toast">
    <div id="toast_picture">
    </div>
    <span id="toast_word">反馈报告生成中{{dynamicPoint}}</span>
</div>
<div *ngIf="IsShowHelperICon()" style="z-index: 20000;position: fixed;box-shadow: 0 0 10px #00ACEE; text-align:center;right:20px;bottom: 20px;width:50px;height:50px;line-height: 50px; border-radius: 100%;background: #749CEB;color:#fff;font-size: .8rem;"
	 (tap)="LogErrorInfo('')">帮
</div>
<!--提示对话框开始-->
<div id="tipMessage">
	<div class="tipMessage-wrap">
		<div class="tipMessage-wrap-title">糟糕，精力值条空空如也！</div>
		<div class="tipMessage-wrap-content">
			你将无法再阅读之后的信息，祝你好运~
		</div>
		<div class="tipMessage-wrap-back" (click)="CloseTipMessage()">返回</div>
	</div>
</div>
<!--提示对话框结束-->




// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/case-practice-hotel.component.html